import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Check, X } from "lucide-react";

export default function GoodreadsPostConfirmation({ item, busy, error, onConfirm, onClose }) {
  const [url, setUrl] = useState("");
  const [confirmed, setConfirmed] = useState(false);
  const dialog = useRef(null);
  useEffect(() => {
    const previousFocus = document.activeElement, previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    dialog.current?.focus();
    return () => { document.body.style.overflow = previousOverflow; previousFocus?.focus(); };
  }, []);
  const close = () => { if (!busy) onClose(); };
  function keyDown(event) {
    if (event.key === "Escape") { event.preventDefault(); close(); }
    if (event.key !== "Tab") return;
    const controls = [...dialog.current.querySelectorAll("button:not(:disabled), input:not(:disabled)")];
    const first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog.current)) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || document.activeElement === dialog.current)) { event.preventDefault(); first?.focus(); }
  }
  return createPortal(<div className="publication-modal-overlay" onMouseDown={event => { if (event.target === event.currentTarget) close(); }}>
    <section className="publication-modal publication-confirmation" ref={dialog} role="dialog" aria-modal="true" aria-labelledby="goodreads-confirmation-title" tabIndex={-1} onKeyDown={keyDown}>
      <header className="publication-modal-header"><h2 id="goodreads-confirmation-title">Mark Goodreads as Posted</h2><button type="button" title="Close" aria-label="Close Goodreads confirmation" disabled={busy} onClick={close}><X size={22} /></button></header>
      <form className="publication-composer" onSubmit={event => { event.preventDefault(); if (confirmed && !busy) onConfirm(url); }}>
        <strong>{item.title}</strong>
        {error && <p className="publication-error" role="alert">{error}</p>}
        <label className="publication-field">Goodreads post URL<input type="url" required maxLength={2048} value={url} disabled={busy} onChange={event => setUrl(event.target.value)} /></label>
        <label className="publication-confirmation-check"><input type="checkbox" checked={confirmed} disabled={busy} onChange={event => setConfirmed(event.target.checked)} />I verified this post appears on Goodreads.</label>
        <div className="publication-modal-actions"><button className="publication-primary" type="submit" disabled={busy || !confirmed || !url.trim()}><Check size={18} />Mark as Posted</button><button type="button" disabled={busy} onClick={close}>Cancel</button></div>
      </form>
    </section>
  </div>, document.body);
}
